import { forwardRef } from 'react';

import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';

import type { ISelectProps } from './input.interface';

import './invoice-input.scss';

export const SelectInvoice = forwardRef<HTMLSelectElement, ISelectProps>(
  (
    {
      label,
      name,
      error,
      disabled = false,
      color = 'default',
      autocomplete = 'off',
      size = 'medium',
      selected,
      value,
      labelSize = 'body2',
      labelWeight = 'semibold',
      ...props
    }: ISelectProps,
    forwardRef
  ) => {
    let inputClass = '';
    if (error) {
      inputClass = 'co-border-error-main co-bg-common-white';
    } else {
      if (color === 'success') {
        inputClass =
          'co-border-pds-success-500 focus:co-border-pds-primary-500 focus:co-border-2';
      } else {
        inputClass =
          'co-border-pds-neutral-300 focus:co-border-pds-primary-500 focus:co-border-2';
      }
    }

    function createSize(): string {
      if (size === 'large') {
        return 'co-h-56px';
      }
      if (size === 'medium') {
        return 'co-h-[44px]';
      }
      return 'co-h-40px';
    }

    return (
      <div className="co-flex co-select-item co-flex-wrap">
        <label
          className={`
                        co-flex-1
                        co-relative
                        co-m-0
                        co-pl-0
                        co-label-${size}
                    `}
          htmlFor={name}
        >
          <select
            autoComplete={autocomplete}
            disabled={disabled}
            className={`
                        ${inputClass}
                        co-input-text-${size}
                        co-px-16px
                        co-w-full
                        co-text-[14px]
                        ${createSize()}
                        co-border-1
                        co-rounded-lg
                        co-font-semibold
                        `}
            value={value}
            name={name}
            id={name}
            ref={forwardRef}
            {...props}
          >
            <option value="" hidden></option>
            {props.options.map((option, index) => {
              return (
                <option key={index} value={option.value}>
                  {option.name}
                </option>
              );
            })}
          </select>
          <span
            className={`
                        co-text-common-default
                        co-px-8px
                        co-rounded-lg
                        ${disabled ? 'co-bg-transparent' : 'co-bg-common-white'}
                        co-absolute
                        co-left-8px
                        ${selected && `co-translate-span-${size}`}
                    `}
          >
            <Typography size={labelSize ?? 'body1'} weight={labelWeight} noWrap>
              {label}
            </Typography>
          </span>
        </label>
        {error && (
          <div className="co-w-full">
            {typeof error === 'string' ? (
              <Typography size={labelSize ?? 'body1'} color="error">
                {error}
              </Typography>
            ) : (
              error
            )}
          </div>
        )}
      </div>
    );
  }
);
